import React, { Component } from 'react'
import classNames from 'classnames'
import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'
import { Translation } from 'react-i18next'
import { resetPasswordValidate } from '../../../containers/employer/validate'
import { useForm, Form, Field } from '../../../form'

/**
 * The Website Reset Password View
 *
 * @author  Pragya Gupta
 */

class ResetPasswordComponent extends Component {
  render() {
    return <ResetPassword {...this.props} />
  }
}

const styles = (theme) => ({
  button: {
    width: '100%'
  },
  textField: {
    marginTop: theme.spacing(4),
    minWidth: 100,
    border: '1px solid gray'
  },
  resize: {
    fontSize: '14px'
  }
})

const ResetPassword = ({ resetPasswordFormSubmit, classes }) => {
  const form = useForm({
    name: 'resetPassword',
    onSubmit: onSubmit,
    defaultValues: { email: '' },
    validator: resetPasswordValidate,
    resetOnSubmit: false
  })

  const { control } = form

  function onSubmit(values) {
    resetPasswordFormSubmit(values)
  }

  return (
    <Translation>
      {(t) => {
        return (
          <Form {...form}>
            <div>
              <div>
                <Field
                  name="email"
                  label={t('employer.resetpsw.email')}
                  inputType="textfield"
                  control={control}
                  className={classNames(classes.textField, classes.resize)}
                  autoFocus
                />
              </div>
            </div>
            <div className="clearfix">
              <div style={{ margin: '25px auto 15px' }}>
                <Button
                  variant="contained"
                  className={classes.button}
                  type="submit"
                >
                  {t('employer.resetpsw.psw')}
                </Button>
              </div>
            </div>
          </Form>
        )
      }}
    </Translation>
  )
}

export default withStyles(styles)(ResetPasswordComponent)
